import firebase from "firebase/app";
import "./firebase";

/**
 * Firebase auth service
 */
export const auth = firebase.auth();

/**
 * signInWithEmailAndPassword
 * @param {Object} credentials Credentials of the user who is trying to login
 * @returns {Promise}
 */
export const signInUser = ({ email, password }) => {
  return auth.signInWithEmailAndPassword(email, password);
};

/**
 * Fetches the Jwt token of the current login user
 * @returns {String} Jwt token of the current user
 */
export const getCurrentUserIdToken = () => {
  return auth.currentUser.getIdToken();
};

/**
 * Fetches the logged in user details
 * @returns {Object} Logged in user details
 */
export const getCurrentUser = () => auth.currentUser;

/**
 * signOutUser
 * @description Log outs the logged in user
 */
export const signOutUser = () => auth.signOut();

/**
 * Fetches the list of sign in methods of a created user in the gip
 * @param {String} email Email of the user whom sign in methods are to be fetched
 * @returns {Array} Array of string which contains signin methods of the user
 */
export const fetchSignInMethodsForEmail = (email) => {
  return auth.fetchSignInMethodsForEmail(email);
};
